import { FavouriteDataModel } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import { RemoteAdminData, RemoteData } from 'app/infrastructure/remote-data';
import { ApiResponse, FavouriteDefinition } from 'app/types-shared';
import { SavedReportDashboardWire } from '../common/types';
import { endpoints } from './endpoints';
import { DashboardItemWire } from './types';

export const api = {

  loadDashboard: async (id: number): Promise<DashboardItemWire> => {
    const response = await new RemoteAdminData(endpoints.dashboardItem)
      .resource<ApiResponse<DashboardItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  loadSavedReports: async (dashboardTypeId: number): Promise<SavedReportDashboardWire[]> => {
    const response = await new RemoteAdminData(endpoints.savedReports(dashboardTypeId))
      .resource<ApiResponse<SavedReportDashboardWire[]>>()
      .all();

    return response.data;
  },

  saveSavedReports: (dashboardTypeId: number, savedReports: SavedReportDashboardWire[]): Promise<void> => {
    return new RemoteAdminData(endpoints.savedReports(dashboardTypeId))
      .resource<void>()
      .save(savedReports);
  },

  executeFavourite: async (
    favouriteDefinition: FavouriteDefinition,
    startIndex?: number,
    maxResults?: number,
    ovverideApi?: boolean): Promise<FavouriteDataModel> => {
    const endpoint = ovverideApi
      ? endpoints.caseReportFavouriteExecute
      : endpoints.favouriteExecute;

    let response;
    if (ovverideApi) {
      response = await new RemoteData(endpoint)
        .resource<any>()
        .filter({
          ...(!!startIndex && { startIndex }),
          ...(!!maxResults && { maxResults })
        })
        .create({ ...favouriteDefinition }, false);
    } else {
      response = await new RemoteData(endpoint)
        .resource<any>()
        .withId(favouriteDefinition.favourite?.v)
        .create({ favouriteDefinition }, false);
    }

    const json = await response.json();

    json.data.id = json.data.favourite;

    return json.data;
  }
};
